import React, { useState, useCallback } from 'react';

export interface Toast {
    id: string;
    title?: string;
    description?: string;
    variant?: 'default' | 'destructive';
    action?: React.ReactNode;
}

type ToastInput = Omit<Toast, 'id'>;

let toastIdCounter = 0;

export function useToast() {
    const [toasts, setToasts] = useState<Toast[]>([]);

    const toast = useCallback((input: ToastInput) => {
        const id = `toast-${++toastIdCounter}`;
        const newToast: Toast = {
            id,
            ...input,
        };

        setToasts((prev) => [...prev, newToast]);

        // Auto-dismiss after 5 seconds
        setTimeout(() => {
            setToasts((prev) => prev.filter((t) => t.id !== id));
        }, 5000);

        return {
            id,
            dismiss: () => {
                setToasts((prev) => prev.filter((t) => t.id !== id));
            },
        };
    }, []);

    const dismiss = useCallback((id: string) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);

    return {
        toast,
        dismiss,
        toasts,
    };
}
